import React from 'react';

export const QuestionCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M6.33343 7.47619V7.09524C6.33343 6.74505 6.4024 6.39828 6.53641 6.07475C6.67043 5.75121 6.86685 5.45724 7.11448 5.20962C7.3621 4.962 7.65607 4.76557 7.9796 4.63156C8.30314 4.49755 8.6499 4.42857 9.00009 4.42857C9.35029 4.42857 9.69705 4.49755 10.0206 4.63156C10.3441 4.76557 10.6381 4.962 10.8857 5.20962C11.1333 5.45724 11.3298 5.75121 11.4638 6.07475C11.5978 6.39828 11.6668 6.74505 11.6668 7.09524V7.47619L9.00009 9.76191V11.2857M9 12.8095V13.9524M1 9C1 11.1217 1.84285 13.1566 3.34315 14.6569C4.84344 16.1571 6.87827 17 9 17C11.1217 17 13.1566 16.1571 14.6569 14.6569C16.1571 13.1566 17 11.1217 17 9C17 6.87827 16.1571 4.84344 14.6569 3.34315C13.1566 1.84285 11.1217 1 9 1C6.87827 1 4.84344 1.84285 3.34315 3.34315C1.84285 4.84344 1 6.87827 1 9Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
